import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React  from 'react';

import {TRITIKDB} from './TRITIKDB';

function App() {

  return (


<div className="App">
<TRITIKDB />

  </div>
  );
}

export default App;